import type { DrivingLessonRecordType } from '@evidia/shared';
import { trpc } from '../../../utils/trcp';
import type { DrivingLessonsRecord } from '../Tabs/TrainingTab/TrainingTab';

export type DrivingLessonData = Record<DrivingLessonRecordType, DrivingLessonsRecord[]>;

export const useDrivingLessonsData = (
	schoolId: string,
	studentId: string,
	secretOptions?: {
		secretCode?: string;
		schoolId?: string;
		registrationNumber?: string;
	},
) => {
	const getDrivingLessonsRecord = trpc.drivingLessonsRecord.getDrivingLessonsRecords.useQuery({
		schoolId,
		studentId,
		...(secretOptions ?? {}),
	});

	const dataGrouped =
		getDrivingLessonsRecord.data?.reduce((acc, item) => {
			acc[item.type] = [...(acc[item.type] ?? []), item];
			return acc;
		}, {} as DrivingLessonData) ?? ({} as DrivingLessonData);

	return {
		isLoading: getDrivingLessonsRecord.isLoading,
		drivingLessonsData: dataGrouped,
		refetch: getDrivingLessonsRecord.refetch,
	};
};
